import API from "@utils/plugins/API";

const DisposalTypeService = {
  all: (params) => {
    return API.get("disposal-types", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("disposal-types", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`disposal-types/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`disposal-types/${id}`);
  },
  destroy: (id) => {
    return API.delete(`disposal-types/${id}`);
  },
};

export default DisposalTypeService;
